import * as React from "react";
import { forwardRef, memo } from "react";
const SvgArrowsUp = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: props.className, ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 17V1M5 1L1 5M5 1L9 5M15 17V6M15 6L11 10M15 6L19 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgArrowsUp);
const Memo = memo(ForwardRef);
export default Memo;
